import { TableHeaders } from '@/shared/components/table/models';

export const CyToCyTableHeaders: TableHeaders[] = [
  { label: 'DATE', key: 'date' },
  { label: 'WO #', key: 'orderNumber' },
  { label: 'BILL TO', key: 'billTo' },
  {
    key: 'masterBillOfLading',
    label: 'M B/L'
  },
  {
    key: 'houseBillOfLading',
    label: 'House BL'
  },
  {
    key: 'referenceNumber',
    label: 'REF'
  },
  {
    key: 'poNumber',
    label: 'PO'
  },
  {
    key: 'deliveryNumber',
    label: 'DELIVERY #'
  },
  {
    key: 'containerNumber',
    label: 'Cont #'
  },
  {
    key: 'containerSize',
    label: 'SZ'
  },
  {
    key: 'containerType',
    label: 'Type'
  },
  {
    key: 'shippingLine',
    label: 'SSL'
  },
  {
    key: 'chassisNumber',
    label: 'CHASSIS #'
  },
  {
    key: 'chassisPool',
    label: 'POOL'
  },
  { label: 'SEAL #', key: 'seal' },
  { label: 'Commodity', key: 'commodity' },
  {
    key: 'weight',
    label: 'WGT'
  },
  {
    key: 'quantity',
    label: 'QTY'
  },
  {
    key: 'unit',
    label: 'Unit'
  },
  {
    key: 'eta',
    label: 'ETA'
  },
  {
    key: 'lastFreeDay',
    label: 'LFD'
  },
  {
    key: 'freeDays',
    label: 'Free Days'
  },
  {
    key: 'freeDaysType',
    label: 'FD Type'
  },
  {
    key: 'dropLive',
    label: 'Drop/Live'
  },
  {
    key: 'overHeight',
    rendererKey: 'info',
    label: 'OH',
    collapsed: true,
    formatter: v => (v ? 'Y' : 'N')
  },
  {
    key: 'overWeight',
    rendererKey: 'info',
    label: 'OW',
    collapsed: true,
    formatter: v => (v ? 'Y' : 'N')
  },
  {
    key: 'haz',
    rendererKey: 'info',
    label: 'HAZ',
    collapsed: true,
    formatter: v => (v ? 'Y' : 'N')
  },
  {
    key: 'hot',
    rendererKey: 'info',
    label: 'HOT',
    collapsed: true,
    formatter: v => (v ? 'Y' : 'N')
  },
  {
    key: 'pulloutLocation',
    label: 'P/OUT'
  },
  {
    key: 'pulloutSchedule',
    label: 'S IN'
  },
  { label: 'DILV', key: 'deliveryLocation' },
  {
    key: 'deliverySchedule',
    label: 'S IN'
  },
  {
    key: 'returnLocation',
    label: 'RTN'
  },
  {
    key: 'returnSchedule',
    label: 'S IN'
  }
];
